// src/utils/analytics/initSectionAnalytics.js

export const initSectionAnalytics = (section, skillCodes) => {
  const skills = {};

  skillCodes.forEach((code) => {
    skills[code] = {
      band: "1",           // canonical difficulty
      bandProgress: 0,     // 0–1
      accuracy: 0,         // weighted accuracy
      attempted: 0,        // weighted attempts
      canPromote: false,
      lastCompletedAt: null,
    };
  });

  return {
    section,
    updatedAt: new Date(),
    skills,
  };
};
